// redex/store.js

import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './users/userSlice';
import tasksReducer from './tasks/taskSlice';
import reportListReducer from "./report/reportSlice"
import dashboardReducer from "./dashboard/dashboardSlice"
import testingReducer from "./testing/testingSlice"
import deployementsReducer from "./deployements/deployementsSlice"
import aiReducer from "./ai/aiSlice"
import shiftGroupReducer from "./shiftgroup/ShiftGroupSlice";
import manualEntryReducer from "./ManualEntry/manualEntrySlice";
import attendanceReducer from "./attendance/attendanceSlice"
import statusReducer from "./status/StatusSlice";
import leaveEntryReducer from "./Approval/LeaveApprovalSlice";
import approvalReducer from "./Approvals/ApprovalSlice";
import employeeReducer from "./EmployeeMaster/EmployeeMasterSlice"
import teamReducer from "./team/teamSlice";
export const store = configureStore({
  reducer: {
    users: usersReducer,
    tasks: tasksReducer,
    report: reportListReducer,
    dashboard: dashboardReducer,
    testing: testingReducer,
    deployements: deployementsReducer,
    ai: aiReducer,
    attendance: attendanceReducer,
    shiftGroup: shiftGroupReducer,
    manualEntry: manualEntryReducer,
    status: statusReducer,
    leaveEntry: leaveEntryReducer,
    approval: approvalReducer,
    employee:employeeReducer,
    team: teamReducer,


  },
});